import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ValidationErrorMessages } from './validation.utils';

@Injectable({
  providedIn: 'root',
})
export class FormManagementService {
  constructor(private fb: FormBuilder) {}

  /**
   * Sets up form validation error handling
   */
  setupFormValidation(
    form: FormGroup,
    label: string,
    onErrorChange: (error: string | null) => void,
  ): Subscription {
    return form.valueChanges.subscribe(() => {
      const nameControl = form.get('name');
      const itemsControl = form.get('items');

      if (nameControl?.touched && nameControl?.invalid) {
        const error = ValidationErrorMessages.getErrorMessage(nameControl, 'name');
        onErrorChange(error);
      } else if (itemsControl?.touched && itemsControl?.invalid) {
        const error = ValidationErrorMessages.getErrorMessage(itemsControl, label, label);
        onErrorChange(error);
      } else {
        onErrorChange(null);
      }
    });
  }

  /**
   * Creates a search form control
   */
  createSearchControl(initialValue: string = ''): FormControl {
    return new FormControl(initialValue);
  }

  /**
   * Creates a select all control
   */
  createSelectAllControl(initialValue: boolean | null = false): FormControl<boolean | null> {
    return new FormControl(initialValue);
  }

  /**
   * Gets the raw form data with selected IDs
   */
  getFormDataWithIds(form: FormGroup, selectedIds: Set<string>): any {
    const rawData = form.getRawValue();
    rawData.ids = [...selectedIds];
    return rawData;
  }

  /**
   * Checks if form is valid and can be saved
   */
  canSaveForm(form: FormGroup): boolean {
    return form.valid;
  }

  /**
   * Handles form snapshot management for different interfaces
   */
  updateFormSnapshot(formSnapshots: Map<string, any>, groupInterface: string, formData: any): void {
    formSnapshots.set(groupInterface, formData);
  }

  /**
   * Gets form data for a specific interface
   */
  getFormSnapshot(formSnapshots: Map<string, any>, groupInterface: string): any {
    return formSnapshots.get(groupInterface);
  }
}
